import {
    CardPersonDto,
    CartItemVoucherAmountDetailDto,
    CartItemVoucherProductDetailDto,
    GetCartItemPresenter,
} from 'store/api-slice/hooks'
import { PRODUCT_TYPE_BUNDLE, VOUCHER_TYPE_PRODUCT } from 'constants/app'
import { VoucherBox } from 'store/vouchers-slice'
import {
    calculateCardDetailForVoucherFromVoucherBundle,
    calculatePersonDetailForVoucherFromVoucherBundle,
    extractProductsDataForVoucherBundle,
    getVoucherFromVoucherBundle,
} from './bundles'
import { VoucherWithDetails } from 'store/api-slice/types'

interface MapCartVouchersDataProps {
    cartVouchers: GetCartItemPresenter[]
    personsData: CardPersonDto[]
}

export const mapCartVouchersData = ({
    cartVouchers,
    personsData,
}: MapCartVouchersDataProps): VoucherBox[] =>
    cartVouchers.map(
        ({
            cartItemId,
            productId,
            productType,
            unitPrice,
            detail,
            itemsBundle,
        }) => {
            const isItemBundle = productType === PRODUCT_TYPE_BUNDLE
            const bundledVoucher = getVoucherFromVoucherBundle(itemsBundle)

            // product/card voucher
            if (isItemBundle && bundledVoucher) {
                const {
                    cartItemId,
                    description,
                    name,
                    productType: bundledVoucherProductType,
                    detail: bundledVoucherDetail,
                } = bundledVoucher
                const { voucherSignature } =
                    bundledVoucherDetail as CartItemVoucherProductDetailDto

                return {
                    voucherType: VOUCHER_TYPE_PRODUCT,
                    voucherSignature,
                    productType: bundledVoucherProductType,
                    cartItemId,
                    productId,
                    unitPrice,
                    personDetail:
                        calculatePersonDetailForVoucherFromVoucherBundle({
                            personsData,
                            description,
                        }),
                    cardDetail:
                        calculateCardDetailForVoucherFromVoucherBundle(name),
                    bundleData: [
                        ...extractProductsDataForVoucherBundle(itemsBundle),
                    ],
                }
            }

            // amount voucher
            const {
                voucherType,
                voucherSignature,
                amount,
                productType: detailedProductType,
            } = detail as CartItemVoucherAmountDetailDto

            return {
                cartItemId,
                productId,
                voucherType,
                voucherSignature,
                amount,
                productType: detailedProductType,
            }
        }
    )

export const checkCartVouchersCoherence = (
    vouchers: VoucherWithDetails[]
): boolean => {
    if (!vouchers.length) return true

    const cartVouchersType = vouchers[0].detail.productType

    return vouchers.every(
        ({ detail }) => cartVouchersType === detail.productType
    )
}

export const checkStateVouchersCoherence = (
    vouchers: VoucherBox[]
): boolean => {
    if (!vouchers.length) return true

    const stateVouchersType = vouchers[0].voucherType || null

    return vouchers.every(
        ({ voucherType }) => stateVouchersType === voucherType
    )
}
